/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { SurveyFieldDto } from './survey-field-dto';
/**
 *
 *
 * @export
 * @interface SurveyContentDto
 */
export interface SurveyContentDto {
  /**
   * Unique identifier of the survey.
   *
   * @type {string}
   * @memberof SurveyContentDto
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id: string;

  /**
   * Name of the survey.
   *
   * @type {string}
   * @memberof SurveyContentDto
   * @example Patient Satisfaction Survey
   */
  name: string;

  /**
   * Description of the survey.
   *
   * @type {string}
   * @memberof SurveyContentDto
   * @example A survey to measure patient satisfaction after each visit.
   */
  description?: string;

  /**
   * Study this survey belongs to.
   *
   * @type {string}
   * @memberof SurveyContentDto
   * @example clinical-trial-2024
   */
  study?: string;

  /**
   * Template defining the fields to fill in the survey.
   *
   * @type {Array<SurveyFieldDto>}
   * @memberof SurveyContentDto
   */
  template: Array<SurveyFieldDto>;

  /**
   * Type of the anonymization.
   *
   * @type {string}
   * @memberof SurveyContentDto
   * @example none
   */
  anonymization_type: SurveyContentDtoAnonymizationTypeEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum SurveyContentDtoAnonymizationTypeEnum {
  None = 'none',
  AllAnswers = 'all_answers',
  Optional = 'optional',
}
